/* Afroyla DD DEAL — Crown Her Deals rotating shelf: schedule + ranking rules (pure, no DOM).
 * 7 shelves × 5 min = 35-min loop on the wall clock from sale start (10:00 ET = shelf 1), 24 loops/day.
 * Order interleaves price bands (set → bag → little gift …) so every 15 min hits each budget.
 * It is a DISPLAY rotation: prices are fixed all day → copy says "swaps / next up", never "price ends".
 * Exposes AFDD.SHELVES, AFDD.shelfState(t), AFDD.rankShelf(items, shelf). Needs afroyla-dd-deal-core.js. */
(function () {
  var A = window.AFDD;
  if (!A) return;
  var SLOT = 5 * 60000;

  // hook: 'save' = "Save up to $X" · 'from' = "From $X" · 'under' = "All under $X" (computed from live items)
  var SHELVES = [
    { key: 'family-sets', label: 'Family Sets', types: ['dd-type-set-family'], lead: '2 bags + 2 wallets + makeup bag', hook: 'save' },
    { key: 'totes-backpacks', label: 'Totes & Backpacks', types: ['dd-type-tote', 'dd-type-backpack'], hook: 'from' },
    { key: 'wallets-makeup', label: 'Wallets & Makeup Bags', types: ['dd-type-wallet', 'dd-type-mini-wallet', 'dd-type-makeup-bag'], lead: 'Little gifts', hook: 'under' },
    { key: 'bag-wallet-sets', label: 'Bag + Wallet Sets', types: ['dd-type-set-bag-wallet'], lead: 'Matching bag + wallet', hook: 'from' },
    { key: 'handbags', label: 'Handbags', types: ['dd-type-handbag', 'dd-type-small-handbag', 'dd-type-forelio-handbag'], hook: 'from' },
    { key: 'crossbody', label: 'Crossbody & Mini Satchels', types: ['dd-type-circle-crossbody', 'dd-type-envelope-crossbody', 'dd-type-mini-satchel'], hook: 'from' },
    { key: '4-bags-sets', label: '4 Bags + Wallet Sets', types: ['dd-type-set-4-bags-wallet'], lead: '4 bags + wallet', hook: 'save' }
  ];
  var TYPE_LABEL = {
    'dd-type-set-family': 'Family Set', 'dd-type-set-bag-wallet': 'Bag + Wallet Set', 'dd-type-set-4-bags-wallet': '4 Bags + Wallet Set',
    'dd-type-tote': 'Tote', 'dd-type-backpack': 'Backpack', 'dd-type-wallet': 'Wallet', 'dd-type-mini-wallet': 'Mini Wallet',
    'dd-type-makeup-bag': 'Makeup Bag', 'dd-type-handbag': 'Handbag', 'dd-type-small-handbag': 'Small Handbag',
    'dd-type-forelio-handbag': 'Forelio Handbag', 'dd-type-circle-crossbody': 'Circle Crossbody',
    'dd-type-envelope-crossbody': 'Envelope Crossbody', 'dd-type-mini-satchel': 'Mini Satchel'
  };

  // Which shelf is up at time t. Before the sale: shelf 1 is previewed and opens at START.
  function shelfState(t) {
    var pre = t < A.START;
    var slot = pre ? 0 : Math.floor((t - A.START) / SLOT);
    var idx = slot % SHELVES.length;
    var startsAt = A.START + slot * SLOT;
    var endsAt = startsAt + SLOT;
    return {
      pre: pre, slot: slot, idx: idx, shelf: SHELVES[idx],
      startsAt: startsAt, endsAt: endsAt,
      next: SHELVES[(idx + 1) % SHELVES.length],
      hasNext: endsAt < A.END,
      // when shelf j is next up (ms timestamp) — used for the lineup rail's relative labels
      nextTimeOf: function (j) { var off = (j - idx + SHELVES.length) % SHELVES.length; return off === 0 ? startsAt : endsAt + (off - 1) * SLOT; }
    };
  }

  function hookText(shelf, items) {
    if (!items.length) return shelf.lead || '';
    var prices = items.map(function (it) { return it.minPrice; });
    var txt = shelf.hook === 'save' ? 'Save up to ' + A.money(Math.round(Math.max.apply(null, items.map(function (it) { return it.maxSave; })))).replace(/\.00$/, '')
      : shelf.hook === 'under' ? 'All under ' + A.money(Math.ceil(Math.max.apply(null, prices))).replace(/\.00$/, '')
      : 'From ' + A.money(Math.min.apply(null, prices));
    return (shelf.lead ? shelf.lead + ' · ' : '') + txt;
  }

  function designOf(it) { var m = /"([^"]+)"/.exec(it.t); return m ? m[1].toLowerCase() : it.t; }

  // Ranking: available first → sets by $ saved desc, other shelves keep feed order →
  // greedy diversity: never repeat a design within the last 3 cards (Aina/Imani stop clumping).
  function rankShelf(items, shelf) {
    var isSet = shelf.hook === 'save' || /set/.test(shelf.key);
    var base = items.map(function (it, i) { return { it: it, i: i }; });
    base.sort(function (a, b) {
      return (b.it.avail - a.it.avail) || (isSet ? b.it.maxSave - a.it.maxSave : 0) || a.i - b.i;
    });
    var pool = base.map(function (x) { return x.it; });
    var out = [];
    while (pool.length) {
      var recent = out.slice(-3).map(designOf);
      var pick = 0;
      for (var i = 0; i < pool.length; i++) {
        if (pool[i].avail !== pool[0].avail) break; // never lift a sold-out card above available ones
        if (recent.indexOf(designOf(pool[i])) < 0) { pick = i; break; }
      }
      out.push(pool.splice(pick, 1)[0]);
    }
    return out;
  }

  A.SHELVES = SHELVES;
  A.TYPE_LABEL = TYPE_LABEL;
  A.SHELF_MS = SLOT;
  A.shelfState = shelfState;
  A.shelfHook = hookText;
  A.rankShelf = rankShelf;
})();
